export const selfDeterminationDefaultCategory = {
    Autonomy: 'Autonomy',
    Competence: 'Competence',
    Relatedness: 'Relatedness',
    Overall: 'Overall',
};

export const selfDeterminationDefaultCategoryInstructions =
    'Please rate how much you agree or disagree with each statement as it relates to you and your team. The only right answer is the honest one, so be true to yourself in your response.';

export const selfDeterminationDefaultInstructions =
    '1. Rate how much you agree or disagree with each statement as it relates to you and your team.';

export const selfDeterminationDefaultReminders =
    'The only right answer is the honest one, so be true to yourself in your response.';

export const selfDeterminationAutonomyQuestions = [
    'I feel that my opinions are valued in my team.',
    'I have the freedom to make decisions about how to approach my tasks.',
    'I am encouraged to express my thoughts and ideas within the team.',
    'I can choose my level of involvement in team activities.',
    'I feel empowered to take initiative when necessary.',
];

export const selfDeterminationCompetenceQuestions = [
    'I believe that my skills are effectively utilized within the team.',
    'I receive constructive feedback that helps me improve my performance.',
    'I feel confident in my abilities to complete the challenges we face.',
    'My team provides opportunities for me to develop new skills.',
    'I am recognized for my contributions to the team\u2019s success.',
];

export const selfDeterminationRelatednessQuestions = [
    'I have strong connections with my teammates.',
    'I feel supported by my team members during challenging times.',
    'My team fosters a sense of belonging and camaraderie.',
    'I believe that my team cares about my well-being.',
    'I enjoy collaborating with my teammates on missions and tasks.',
];

export const selfDeterminationOverallQuestions = [
    'Being part of this team is important to me.',
    'I am driven to work hard for the success of my team.',
    'I feel a strong sense of commitment to my team\u2019s goals.',
    'I take pride in being a member of this special forces unit.',
    'I believe that my contributions make a meaningful difference to the team.',
];

export const selfDeterminationName = 'Self Determination';
export const selfDeterminationDescription =
    'Evaluates motivation level and sense of autonomy, competence, and relatedness.';
